import React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';

import { cn } from 'src/component/ds/utils';

/*
 * "Tabs (line) - Vega" in Figma: the active tab carries a 1px bottom border in
 * --ds-text. The segmented variant is a separate Figma component, not built here.
 */

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('ds-inline-flex ds-items-center ds-gap-1 ds-border-b ds-border-border', className)}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'ds-inline-flex ds-items-center ds-justify-center ds-gap-1.5 ds-whitespace-nowrap',
      'ds-h-ds-md ds-px-2 ds-pb-2 -ds-mb-px ds-border-b ds-border-transparent',
      'ds-text-ds-sm ds-font-medium ds-text-muted-foreground',
      'focus-visible:ds-outline-none focus-visible:ds-shadow-ds-focus',
      'disabled:ds-pointer-events-none disabled:ds-opacity-50',
      'data-[state=active]:ds-border-foreground data-[state=active]:ds-text-foreground',
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'ds-pt-4 focus-visible:ds-outline-none focus-visible:ds-shadow-ds-focus',
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
